import { createAction, props } from '@ngrx/store';

const namespace = 'RequisitionsGlobal';

const getActionType = (name: string) => `[${namespace}] ${name}`;

const actions = {
  refreshFromWS: createAction(
    getActionType('refreshFromWS'),
    props<{ payload: { ids: number[]; all: boolean } }>(),
  ),
};

export { actions as RequisitionsGlobalActions };
